import React, { useContext } from 'react';
import { Table, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartArrowDown } from '@fortawesome/free-solid-svg-icons';

import { BookOnlineContext } from '../context';

const CartItems = () => {
  const { services, isBusiness, cartItems, cartTotal } = useContext(BookOnlineContext);
  
  return (
    <div className="d-none d-md-block">
      <div className="BookingForm-Cart">
        <div className="BookingForm-Cart__Content">
          {
            cartItems && cartItems.length > 0 ?
              <Table className="BookingForm-CartItems">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    services.filter(service => cartItems.includes(service.id)).map(item => (
                      <tr key={item.id}>
                        <td className="text-secondary">{item.name}</td>
                        <td>${isBusiness ? item.businessPrice : item.homePrice}</td>
                      </tr>
                    ))
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <th>Subtotal</th>
                    <th>{cartTotal}</th>
                  </tr>
                </tfoot>
              </Table> : 
              <div className="BookingForm-Cart__IsBlank">
                <FontAwesomeIcon color="#dddddd" size="5x" icon={faCartArrowDown} />
                <p className="text-secondary small mt-3">Book the services in a few clicks! Our experts are available to help you.</p>
              </div>
          }
        </div>
      </div>
      <Button
        block
        variant="danger"
        className="BookingForm-Cart__CheckoutBtn"
      >Proceed to Checkout</Button>
    </div>
  );
};

export default CartItems;